module.exports = __webpack_public_path__ + "static/media/banner-01.f0a86d08.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner-01.webp
// module id = 271
// module chunks = 0